import { useState, useEffect, useRef } from "react";
import axios from "../services/api/api";

const cache = new Map();

export default function useAuthenticatedImage(url) {
  const [blobUrl, setBlobUrl] = useState(() => (url ? cache.get(url) || null : null));
  const urlRef = useRef(url);

  useEffect(() => {
    urlRef.current = url;

    if (!url) return;

    if (cache.has(url)) {
      setBlobUrl(cache.get(url));
      return;
    }

    axios
      .get(url, { responseType: "blob" })
      .then((res) => {
        const objectUrl = URL.createObjectURL(res.data);
        cache.set(url, objectUrl);
        if (urlRef.current === url) {
          setBlobUrl(objectUrl);
        }
      })
      .catch(() => {});
  }, [url]);

  return blobUrl;
}
